export default __webpack_public_path__ + "static/media/qr-code-scan.be75cd92.png";